import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormAttachProcedureStaff } from "src/api/procedure-staff/procedureStaff";
import { Pagination } from "src/types/api/invoice";
import { AddonStaffForm, GetProcedureStaff, ProcedureStaff, ProcedureStaffForm } from "src/types/api/service";

interface ProcedureStaffState {
    procedureStaffs: ProcedureStaff[] | null,
    proceduresStaff: ProcedureStaff[] | null,
    loading: boolean,
    pagination: Pagination,
}

const initialState: ProcedureStaffState = {
    procedureStaffs: null,
    proceduresStaff: null,
    loading: false,
    pagination: {
        total: 0,
        currentPage: 1,
        limit: 10,
        from: 0,
        to: 0,
    },
}

const procedureStaffSlices = createSlice({
    name: "services/procedureStaff",
    initialState,
    reducers: {
        doGetProcedureStaff(
            state,
            action: PayloadAction<GetProcedureStaff>
        ) {
            state.loading = true;
        },
        doGetProcedureStaffSuccess(
            state,
            action: PayloadAction<ProcedureStaff[]>
        ) {
            state.loading = false;
            state.procedureStaffs = action.payload
        },
        doGetProceduresStaffSuccess(
            state,
            action: PayloadAction<{
                proceduresStaff: ProcedureStaff[],
                pagination: Pagination;
            }>
        ) {
            state.proceduresStaff = action.payload.proceduresStaff;
            state.loading = false;
            state.pagination = action.payload.pagination;
        },
        doGetProcedureStaffFail(
            state,
        ) {
            state.loading = false;
        },
        doAttachProcedureStaff(
            state,
            action: PayloadAction<{
                procedureId: number,
                staffId: number,
                form: FormAttachProcedureStaff,
                onSuccess?: () => void,
                onFail?: (msg: string) => void,
            }>
        ) {
            state.loading = true;
        },
        doAttachProcedureStaffSuccess(
            state,
        ) {
            state.loading = false;
        },
        doAttachProcedureStaffFail(
            state,
        ) {
            state.loading = false;
        },
        doDetachProcedureStaff(
            state,
            action: PayloadAction<{
                procedureId: number,
                staffId: number,
                onSuccess?: () => void,
                onFail?: (msg: string) => void,
            }>
        ) {
            state.loading = true;
        },
        doDetachProcedureStaffSuccess(
            state,
        ) {
            state.loading = false;
        },
        doDetachProcedureStaffFail(
            state,
        ) {
            state.loading = false;
        },
        doUpdateProcedureStaff(
            state,
            action: PayloadAction<{
                procedureId: number,
                procedureStaffs: ProcedureStaffForm[],
                addonStaffs: AddonStaffForm[],
                onSuccess: () => void,
                onFail: (err: string) => void,
            }>
        ) {
            state.loading = true;
        },
        doUpdateProcedureStaffSuccess(
            state
        ) {
            state.loading = false;
        },
        doUpdateProcedureStaffFail(
            state
        ) {
            state.loading = false;
        },
    }
});

export const {
    doGetProcedureStaff,
    doGetProcedureStaffFail,
    doGetProcedureStaffSuccess,
    doGetProceduresStaffSuccess,
    doAttachProcedureStaff,
    doAttachProcedureStaffFail,
    doAttachProcedureStaffSuccess,
    doDetachProcedureStaff,
    doDetachProcedureStaffFail,
    doDetachProcedureStaffSuccess,
    doUpdateProcedureStaff,
    doUpdateProcedureStaffFail,
    doUpdateProcedureStaffSuccess,
} = procedureStaffSlices.actions;

export default procedureStaffSlices.reducer;
